import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Award, CalendarCheck, Quote, Zap } from "lucide-react";
import { api } from "./api";

export function MotivationCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api("/motivation/today").then(setD).catch(() => {}); }, []);
  if (!d?.quote) return null;
  return (
    <div className="col-span-2 md:col-span-4 bg-[#c1ff72] text-black p-8 md:p-10 relative overflow-hidden" data-testid="motivation-card">
      <Quote className="absolute -right-4 -top-4 w-40 h-40 opacity-10" />
      <p className="text-xs uppercase tracking-[0.2em] font-bold mb-4">Motivation des Tages</p>
      <p className="font-['Bebas_Neue'] text-3xl md:text-5xl leading-[0.95] max-w-3xl" data-testid="motivation-quote">„{d.quote.text}“</p>
      {d.impulse && <p className="mt-6 flex gap-2 text-sm font-medium max-w-2xl" data-testid="motivation-impulse"><Zap className="w-4 h-4 shrink-0 mt-0.5" />Impuls: {d.impulse.text}</p>}
    </div>
  );
}

export function TodayCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api("/me/plan").then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const s = d.plan?.sessions.find((x) => x.date === d.today);
  const p = d.plan?.progress;
  return (
    <Link to="/training/plan" className="col-span-2 bg-[#121212] border border-white/10 hover:border-[#c1ff72]/60 p-6 flex flex-col justify-between transition-colors" data-testid="today-card">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#71717A]"><CalendarCheck className="w-4 h-4 text-[#c1ff72]" />Heute im Plan</p>
      {!d.plan ? <p className="text-white mt-4">Noch kein Wochenplan. <span className="text-[#c1ff72]">Jetzt erstellen</span></p>
        : s ? <div className="mt-4"><p className="font-['Bebas_Neue'] text-3xl text-white leading-none">{s.title}</p><p className="text-sm text-[#A1A1AA] mt-1">{s.minutes} Min · {s.items.length} Übungen · {s.status === "done" ? "erledigt" : "offen"}</p></div>
          : <p className="text-white mt-4">Heute ist Ruhetag – Erholung gehört zum Training.</p>}
      {p && <div className="mt-4" data-testid="today-week-progress"><p className="text-xs text-[#71717A] flex items-center gap-1">Woche: {p.done}/{p.planned} Einheiten<ArrowRight className="w-3 h-3 ml-auto" /></p>
        <div className="h-1.5 bg-white/10 mt-2"><div className="h-full bg-[#c1ff72] transition-[width] duration-500" style={{ width: `${p.planned ? (p.done / p.planned) * 100 : 0}%` }} /></div></div>}
    </Link>
  );
}

export function Achievements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api("/me/achievements").then((d) => setItems(d.items)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="col-span-2 md:col-span-4 bg-[#121212] border border-white/10 p-6" data-testid="achievements">
      <p className="text-xs uppercase tracking-[0.2em] text-[#71717A] mb-4">Erfolge</p>
      <div className="flex flex-wrap gap-2">{items.map((a) => (
        <span key={a.id} data-testid={`achievement-${a.id}`} className={`flex items-center gap-1.5 px-3 py-2 text-xs border ${a.reached ? "border-[#c1ff72] text-[#c1ff72]" : "border-white/10 text-[#52525B]"}`}>
          <Award className="w-3.5 h-3.5" />{a.label}
        </span>
      ))}</div>
    </div>
  );
}
